import React, { useState } from "react";
import "../App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { GenesysDevIcon, GenesysDevIcons } from "genesys-dev-icons";
import { DxCheckbox } from "genesys-react-components";
import { removeWrapupCodesFromQueue } from "../utilities/genesysCloudUtils";

export function Queues({
  queues,
  setQueues,
  pageNumber,
  pageSize,
  queueCache,
  setQueueCache,
}) {
  const [editQueueWrapupCodes, setEditQueueWrapupCodes] = useState(null);
  const [removeWrapupCodesList, setRemoveWrapupCodesList] = useState([]);

  const handleEditClick = (queueId) => {
    console.log("Edit button clicked");
    if (editQueueWrapupCodes === queueId) {
      setEditQueueWrapupCodes(null);
      setRemoveWrapupCodesList([]);
      return;
    }
    setEditQueueWrapupCodes(queueId);
  };

  const handleWrapupCodeCheckChange = (code, checked) => {
    if (checked) {
      setRemoveWrapupCodesList((prevList) => [...prevList, code]);
    } else {
      setRemoveWrapupCodesList((prevList) =>
        prevList.filter((item) => item !== code)
      );
    }
  };

  const handleRemoveWrapupCodes = (queueId) => {
    console.log("Remove wrapup codes button clicked");
    console.log("Queue ID: ", queueId);
    console.log("Wrapup codes to remove: ", removeWrapupCodesList);

    removeWrapupCodesFromQueue(queueId, removeWrapupCodesList)
      .then(() => {
        console.log("Wrapup codes removed successfully");

        // Update the cache to reflect the removed wrap-up codes
        setQueueCache((prevCache) => ({
          ...prevCache,
          [queueId]: prevCache[queueId].filter(
            (code) => !removeWrapupCodesList.includes(code.id)
          ),
        }));
        console.log(queueCache);

        // Update the queues state to reflect the removed wrap-up codes
        setQueues((prevQueues) =>
          prevQueues.map((queue) =>
            queue.id === queueId
              ? {
                  ...queue,
                  wrapUpCodes: queue.wrapUpCodes.filter(
                    (code) => !removeWrapupCodesList.includes(code.id)
                  ),
                }
              : queue
          )
        );
        setRemoveWrapupCodesList([]);
        setEditQueueWrapupCodes(null);
      })
      .catch((error) => {
        console.error("Error removing wrapup codes: ", error);
      });
  };

  return (
    <>
      <table className="table queues-table">
        <thead>
          <tr>
            <th>Count</th>
            <th>Queue Name</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {queues.map((queue, index) => {
            return (
              <tr key={queue.id}>
                <th className="index">
                  {pageNumber === 1
                    ? index + 1
                    : (pageNumber - 1) * pageSize + index + 1}
                </th>
                <td>{queue.name}</td>
                <td>
                  {!queue.wrapUpCodes ? (
                    <FontAwesomeIcon icon={faCircleNotch} spin />
                  ) : (
                    queue.wrapUpCodes &&
                    queue.wrapUpCodes.length !== 0 && (
                      <div className="collapse collapse-arrow">
                        <input type="checkbox" />
                        <div className="collapse-title">
                          Wrapup Codes: {queue.wrapUpCodes.length}
                        </div>
                        <div className="collapse-content">
                          <div className="queue-wrapupcodes-list">
                            {editQueueWrapupCodes === queue.id ? (
                              queue.wrapUpCodes
                                .sort((a, b) => a.name.localeCompare(b.name))
                                .map((code, index) => {
                                  return (
                                    <DxCheckbox
                                      key={index}
                                      label={code.name}
                                      value="item-value"
                                      initialValue={false}
                                      name="name-string"
                                      className="clazzy-checkbox"
                                      onCheckChanged={(checked) =>
                                        handleWrapupCodeCheckChange(
                                          code.id,
                                          checked
                                        )
                                      }
                                    />
                                  );
                                })
                            ) : (
                              <ol>
                                {queue.wrapUpCodes
                                  .sort((a, b) => a.name.localeCompare(b.name))
                                  .map((code, index) => {
                                    return (
                                      <li
                                        key={index + 1}
                                        className="label-text"
                                      >
                                        <span className="label-text">
                                          {code.name}
                                        </span>
                                      </li>
                                    );
                                  })}
                              </ol>
                            )}
                          </div>
                          <div className="queue-wrapupcodes-list-actions">
                            <button
                              onClick={() => handleEditClick(queue.id)}
                              className="wrapup-action-button"
                            >
                              <GenesysDevIcon
                                icon={GenesysDevIcons.AppDocumentEdit}
                              />
                            </button>
                            {editQueueWrapupCodes === queue.id && (
                              <button
                                onClick={() =>
                                  handleRemoveWrapupCodes(queue.id)
                                }
                                className="wrapup-action-button"
                              >
                                <GenesysDevIcon
                                  icon={GenesysDevIcons.EditorTrash}
                                />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
}
